<template>
  <div class="vx-card">
    <div class="vx-card__body">
      <div class="vx-row px-5 pb-6 flex">
        <label class="custom-file-upload">
          <input
            type="file"
            id="file"
            ref="file"
            v-on:change="handleFileUpload()"
          />

          <feather-icon icon="PaperclipIcon" svgClasses="h-4 w-4" class="ico" />
          {{ $t("ChooseFile") }}
          <span v-if="uploadedFileName" class="file-name">{{
            uploadedFileName
          }}</span>
        </label>
        <vs-button
          @click="uploadFile()"
          class="bg_m_green float-right"
          v-if="fileUploaded"
          :disabled="disabledBtn"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
          {{ $t("UploadFile") }}
        </vs-button>
      </div>
      <form class="transition-opacity duration-300">
        <div
          class="vx-row px-5 gap-x-6 items-start justify-between gap-y-1 flex flex-row-reverse"
        >
          <div class="flex gap-x-6 gap-y-2 md:w-2/3 flex-grow w-full flex-wrap">
            <div class="md:w-1/3 w-full">
              <label class="vs-select--label">{{ $t("WarehouseName") }}</label>
              <v-select
                class="m-0"
                label="name"
                name="warehouse"
                :searchable="false"
                :options="allWarehouses"
                :loading="warehousesLoading"
                v-model="storeId"
                @input="getShelves"
                v-validate="{ required: true }"
                :reduce="(x) => x.id"
                :disabled="
                  reservationList.length ? true : false || !allWarehouses.length
                "
              >
              </v-select>
              <span
                class="text-danger text-sm mt-4"
                v-show="errors.has('warehouse')"
                >{{ errors.first("warehouse") }}</span
              >
            </div>
            <div class="flex-grow">
              <label class="vs-select--label">{{ $t("Description") }}</label>
              <vs-textarea rows="1" v-model="description" class="my-0" />
            </div>
          </div>
        </div>
      </form>
      <div
        class="vx-card__body flex flex-col transition-opacity duration-300"
        :class="[
          storeId ? '' : 'opacity-50 cursor-not-allowed pointer-events-none',
        ]"
      >
        <form class="w-full flex justify-center">
          <div class="mb-6 flex items-end gap-2 w-full flex-wrap">
            <div class="lg:w-1/2 flex-grow sm:w-1/3 w-full">
              <label class="vs-select--label">{{ $t("Product") }}</label>
              <treeselect
                v-model="reservationItem.stockId"
                name="stockid"
                :multiple="false"
                :placeholder="$t('Search')"
                :async="true"
                :load-options="loadOptions"
                :class="{ 'is-invalid': errors.has('stockid') }"
                v-validate="'required'"
                @select="storeProduct"
              />
            </div>
            <div class="lg:w-1/12 sm:w-1/6 w-full">
              <vs-input
                v-model="reservationItem.count"
                name="pcount"
                @input="acceptOnlyNumbersOnCount($event)"
                :label="$t('Count')"
                v-validate="{ required: 'true' }"
                class="count-input-reservation"
              />
            </div>
            <div class="lg:w-1/6 sm:w-1/4 w-full">
              <label class="vs-select--label">{{ $t("Shelve") }}</label>
              <v-select
                label="name"
                name="shelve"
                :options="listOfShelvesRelated"
                v-model="reservationItem.shelveId"
                @input="storeShelveName"
                :reduce="(x) => x.id"
                v-validate="'required'"
                :key="storeId"
              >
              </v-select>
            </div>
            <div class="lg:w-1/12 sm:w-1/8 w-full mt-4 flex justify-end">
              <vs-button
                color="success"
                type="gradient"
                class="m-0 py-3 px-5"
                icon-pack="feather"
                icon="icon-plus"
                id="add-btn"
                @click.prevent="onAddItemButtonClick()"
                >{{ $t("Add") }}</vs-button
              >
            </div>
          </div>
        </form>
        <vs-table :data="reservationList" class="custom-tbl">
          <template slot="thead">
            <th style="width: 5%">#</th>
            <th style="width: 6%">{{ $t("ItemCode") }}</th>
            <th style="width: 38%">{{ $t("ProductName") }}</th>
            <th style="width: 5%">{{ $t("Count") }}</th>
            <th style="width: 13%">{{ $t("Shelve") }}</th>
            <th style="width: 8%">{{ $t("Action") }}</th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="i" v-for="(reservationItem, i) in data">
              <vs-td>
                {{ i + 1 }}
              </vs-td>
              <vs-td>
                {{ reservationItem.itemCode }}
              </vs-td>
              <vs-td>
                {{ reservationItem.name }}
              </vs-td>
              <vs-td
                class="flex justify-center items-center w-full count-input-reservation"
              >
                <vs-input
                  v-model="reservationItem.count"
                  @input="acceptOnlyNumbersOnListItemCount($event, i)"
                  class="w-24"
                  style="direction: ltr"
                />
              </vs-td>
              <vs-td>
                {{ reservationItem.shelveName }}
              </vs-td>
              <vs-td>
                <div class="flex w-full gap-2 justify-center">
                  <vs-button
                    @click="onRemoveItemButtonClick(i)"
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    class="d-inline"
                  ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="flex gap-4 w-full justify-end py-6">
          <vs-button
            type="filled"
            color="#3ec9d6"
            @click.prevent="onResetFormButtonClick"
            >{{ $t("Reset") }}</vs-button
          >
          <vs-button
            type="filled"
            @click.prevent="onSubmitFormClick"
            :disabled="!reservationList.length"
            >{{ $t("Save") }}</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import vSelect from "@/components/CustomVSelect.vue";
import "@/assets/scss/vuesax-rtl/pages/_warehouse.scss";
import { Validator } from "vee-validate";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
const dict = {
  custom: {
    warehouse: {
      required: "لطفا نام انبار را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "warehouseManagement_Inventory_CheckIn_Reservation",
  components: {
    "v-select": vSelect,
    Treeselect,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      reservationItem: {},
      searchQueryNew: "",
      searchQueryOld: "",
      storeId: null,
      listOfShelvesRelated: [],
      reservationList: [],
      file: "",
      fileUploaded: false,
      disabledBtn: false,
      showLoading: false,
      uploadedFileName: "",
      emptyFileInRefs: "",
      description: "",
      warehousesLoading: true,
    };
  },
  computed: {
    ...mapGetters({
      allWarehouses: "warehouse/listWithShelves",
    }),
  },
  mounted() {
    this.emptyFileInRefs = this.$refs.file.files;
    this.fetchWarehouses()
      .then(() => {
        this.warehousesLoading = false;
      })
      .catch((err) => (this.warehousesLoading = false));
  },
  methods: {
    ...mapActions({
      fetchWarehouses: "warehouse/fetchList",
      fetchSearch: "stock/fetchSearch",
      createReservation: "reservation/reserve",
      rechargeReservation: "reservation/recharge",
      importReservationReserve: "excel/importReservationReserve",
      importReservationRecharge: "excel/importReservationRecharge",
    }),
    storeProduct(data) {
      this.reservationItem.name = data.label;
      this.reservationItem.itemCode = data.itemCode;
    },
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchSearch(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.stockId,
                  label: element.stockName,
                  itemCode: element.itemCode,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 500);
    },
    getShelves() {
      const selectedWarehouse = this.allWarehouses.find(
        (warehouse) => warehouse.id == this.storeId
      );
      if (selectedWarehouse) {
        const shelves = selectedWarehouse.shelveQueries;
        this.listOfShelvesRelated = shelves;
      }
    },
    storeShelveName() {
      const selectedShelve = this.listOfShelvesRelated.filter(
        (x) => x.id == this.reservationItem.shelveId
      )[0];
      if (selectedShelve) {
        this.reservationItem.shelveName = selectedShelve.name;
      }
    },
    clearReservation() {
      this.reservationItem = {};
    },
    checkForDuplicateReservation(stockId) {
      const isDuplicate = this.reservationList.some(
        (item) => item.stockId == stockId
      );
      if (isDuplicate) {
        this.$swal({
          position: "center-center",
          type: "warning",
          text: "این کالا در لیست وجود دارد",
          showConfirmButton: false,
          timer: 3000,
        });
      }
      return isDuplicate;
    },
    async onAddItemButtonClick() {
      const validateForm = await this.$validator.validateAll();
      if (validateForm) {
        const isDuplicateInList = this.checkForDuplicateReservation(
          this.reservationItem.stockId
        );
        if (!isDuplicateInList) {
          this.addItemToReservationList();
        }
        this.clearReservation();
        this.$validator.reset();
      }
    },
    addItemToReservationList() {
      this.reservationList.push(this.reservationItem);
    },
    removeItemFromReservationList(index) {
      this.reservationList.splice(index, 1);
    },
    onRemoveItemButtonClick(index) {
      this.$swal({
        title: "آیا از حذف این محصول از لیست اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeItemFromReservationList(index);
        }
      });
    },
    acceptOnlyNumbersOnCount(event) {
      let itemCount = Number(event.replace(/\D/g, ""));
      if (itemCount < 1) itemCount = null;
      this.reservationItem.count = itemCount;
    },
    acceptOnlyNumbersOnListItemCount(event, index) {
      let itemCount = Number(event.replace(/\D/g, ""));
      if (itemCount < 1) itemCount = null;
      this.reservationList[index].count = itemCount;
    },
    resetForm() {
      this.storeId = null;
      this.reservationList = [];
      this.reservationItem = {};
      this.description = "";
    },
    onResetFormButtonClick() {
      this.$swal({
        title: "آیا از شروع مجدد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.resetForm();
        }
      });
    },
    preparePayload() {
      let reservationArray = [];
      for (let item of this.reservationList) {
        reservationArray.push({
          stockId: item.stockId,
          shelveId: item.shelveId,
          count: Number(item.count),
        });
      }
      let reasonType = null;
      if (this.$props.mode == "recharge") reasonType = 11;
      else if (this.$props.mode == "reserve") reasonType = 12;
      const payload = {
        storeId: this.storeId,
        reservationRequesterCommand: {
          id: "1",
          name: "admin",
        },
        reasonCommand: {
          id: 0,
          reasonType: reasonType,
          description: this.description,
        },
        reservationTransactionItemsCommand: reservationArray,
      };
      return payload;
    },
    validateCountes() {
      let areAllCountesNaturalNumbers = true;
      for (let item of this.reservationList) {
        if (!Number(item.count) > 0) {
          areAllCountesNaturalNumbers = false;
        }
      }
      if (!areAllCountesNaturalNumbers) {
        this.$swal({
          position: "center-center",
          type: "warning",
          text: "تعداد نمی‌تواند خالی باشد",
          showConfirmButton: false,
          timer: 3000,
        });
      }
      return areAllCountesNaturalNumbers;
    },
    onSubmitFormClick() {
      if (this.validateCountes()) {
        const payload = this.preparePayload();
        if (this.$props.mode === "reserve") {
          this.createReservation(payload)
            .then(() => {
              setTimeout(() => {
                this.resetForm();
              }, 3000);
            })
            .catch((err) => {
              // this.handleErrorOnSubmit(err);
            });
        } else if (this.$props.mode === "recharge") {
          this.rechargeReservation(payload)
            .then(() => {
              setTimeout(() => {
                this.resetForm();
              }, 3000);
            })
            .catch((err) => {
              // this.handleErrorOnSubmit(err);
            });
        }
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.file.name;
      this.fileUploaded = true;
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.files = this.emptyFileInRefs;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
    uploadFile() {
      this.showLoading = true;
      this.disabledBtn = true;
      let formData = new FormData();
      formData.append("file", this.file);
      const showSuccess = () => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "فایل مورد نظر با موفقیت بارگذاری شد!",
          showConfirmButton: false,
          timer: 4000,
        });
      };
      if (this.$props.mode === "reserve") {
        this.importReservationReserve(formData).then(() => {
          showSuccess();
        });
      } else {
        this.importReservationRecharge(formData).then(() => {
          showSuccess();
        });
      }
      setTimeout(() => {
        this.removeUploadFile();
        this.disabledBtn = false;
        this.showLoading = false;
      }, 2000);
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
}
.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}

.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}
</style>

<!-- no scoped so vuesax's input gets this style -->
<style>
.count-input-reservation input {
  text-align: center !important;
}
</style>
